import React, { useState, useEffect } from 'react';
import '../../scss/users.scss';
import Header from '../layout/Header';
import Sidebar from '../layout/Sidebar';
import Footer from '../layout/Footer';
import Breadcrumbs from '../Reusables/Breadcrumbs';
import SearchSection from '../Reusables/SearchSection';
import Spinner from '../Reusables/Spinner';
import getProfile from '../actions/Profile.js';
import { useNavigate, useLocation } from "react-router-dom";
import ProfileHeader from '../layout/ProfileHeader';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { parseBreadcrumbsList } from '../../store/Actions';
import DeleteUser from '../popups/DeleteUser';
import Cookies from 'js-cookie';
import RefreshToken from '../actions/RefreshToken';

import edit from '../../images/common/edit.png';
import trash from '../../images/common/trash.png';
import editDark from '../../images/common/edit-dark.png';
import trashDark from '../../images/common/trash-dark.png';
import placeholder from '../../images/common/logo-placeholder.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';
import { convertUTCToPST } from '../Reusables/Function';

function Users(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const filename = 'Users';
    const[isLoading, setLoading] = useState(true);
    const [userListValues, setUserListValues] = useState(null);
    const [deletedUser, setDeleteUser] = useState(null);
    const [reload, setReload] = useState(false);
    const [usersList, setUsersList] = useState(null);
    const [downloadArray, setDownloadArray] = useState([]);
    const [showDeleteUser, setShowDeleteUser] = useState(false);
    const userId = useSelector((state) => state.userId);
    const [enable, setEnable] = useState(true);
    const searchValues = {
        isFilter: false,
        isCreate: true,
        placeholder: "Search User"
    }
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const tableHeaders = [
        { "name": "First Name", "sort": true, "width": "153px" },
        { "name": "Last Name", "sort": true, "width": "134px" },
        { "name": "Role", "sort": true, "width": "150px" },
        { "name": "Email Id", "sort": false, "width": "204px" },
        { "name": "Phone", "sort": false, "width": "125px" },
        { "name": "Last Updated", "sort": true, "width": "147px" },
        { "name": "Last Login", "sort": true, "width": "156px" },
        { "name": "Actions", "sort": false, "width": "95px" }
    ];
    const breadcrumbsList = [
        { "name": "Home", "url": "" },
        { "name": "Users", "url": "users/list" }
    ];
    const headers = [
        { label: "First Name", key: "firstName" },
        { label: "Last Name", key: "lastName" },
        { label: "Role", key: "roleName" },
        { label: "Email Id", key: "email" },
        { label: "Phone", key: "phoneNumber" },
        { label: "Last Updated", key: "lastUpdatedTime" },
        { label: "Last Login", key: "lastLogin" }
    ];

    const handleCloseDeleteUserPopup = () => setShowDeleteUser(false);
    const handleShowDeleteUserPopup = () => setShowDeleteUser(true);

    const addDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        editElement.src = editDark;
        trashElement.src = trashDark;
    }

    const removeDarkImage = (e, index) => {
        const editElement = document.getElementById('edit'+index)
        const trashElement = document.getElementById('trash'+index)
        editElement.src = edit;
        trashElement.src = trash;
    }

    useEffect(() => {
        window.scroll(0, 0);
        dispatch(parseBreadcrumbsList(breadcrumbsList));

        const path = new URLSearchParams(location.search);
        const search = path.has('search') ? path.get('search') : '';
        const sortBy = path.has('sort') ? path.get('sort') : '';
        const sortOrder = path.has('sort_order') ? path.get('sort_order') : '';

        const endpoint = search ? (`/api/users/?search=${search}${sortBy ? `&sort=${sortBy}` : ''}
        ${sortOrder ? `&sort_order=${sortOrder}` : ''}`) : 
        (`/api/users/?${sortBy ? `sort=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}`);
        const endpointDownloadArray = `/api/users/?download=true${search ? `&search=${search}` : ''}${sortBy ? `&sort=${sortBy}` : ''}
        ${sortOrder ? `&sort_order=${sortOrder}` : ''}`

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else if(accesstoken === 'noToken') {
                navigate('/login', {state : {path : window.location.pathname+window.location.search+window.location.hash}});
            }
            else {
                // Fot list
                getUserList(endpoint, accesstoken);

                // For download
                getProfile.GetUserList(endpointDownloadArray, accesstoken, (data) => {
                    if (data.status == 200) {
                        setDownloadArray(data.data.data);
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }, [reload])

    const getUserList = (endpoint, accesstoken) => {
        getProfile.GetUserList(endpoint, accesstoken, (data) => {
            if (data.status == 200) {
                setUserListValues(data.data.data);
                setLoading(false);
                setUsersList(data.data.data);
            } else if(data.status == 401) {
                navigate("/login")
            }
        });
    }

    const createNewUser = () => {
        navigate('/users/new');
    }

    const handleEdit = (e, userId) => {
        e.stopPropagation();
        navigate(`/users/${userId}/edit`);
    }

    const handleDelete = (e, userId) => {
        e.stopPropagation();
        setDeleteUser(userId);
        handleShowDeleteUserPopup();
        setEnable(true);
    }

    const handleDeleteUser = () => {
        setEnable(false);
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getProfile.DeleteUser(`/api/users/delete?userId=${deletedUser}`, accesstoken, (data) => {
                    if (data.status == 200) {
                        if(userId == deletedUser) {
                            navigate('/login')
                        }
                        setReload(!reload);
                        handleCloseDeleteUserPopup();
                    } else if(data.status == 401) {
                        navigate("/login")
                    }
                });
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const handleOverview = (id) => {
        navigate(`/users/${id}/view`);
    }

    const callSearchApi = (query) => {
        const path = new URLSearchParams(location.search);
        const sortBy = path.has('sort') ? path.get('sort') : '';
        const sortOrder = path.has('sort_order') ? path.get('sort_order') : '';

        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getUserList(`/api/users/?search=${query}${sortBy ? `&sort=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}`, accesstoken);
                navigate(sortBy ? (`/users/list/?${sortBy ? `sort=${sortBy}` : ''}${sortOrder ? `&sort_order=${sortOrder}` : ''}${query ? `&search=${query}` : ''}`) : 
                (`/users/list/?search=${query}`))        
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    const callSortApi = (dataset) => {
        const path = new URLSearchParams(location.search);
        const search = path.has('search') ? path.get('search') : '';
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        const callApi = (accesstoken) => {
            if(accesstoken === '') {
                navigate('/login');
            }
            else {
                getUserList(search ? (`/api/users/?search=${search}&sortKey=${dataset.sortBy}&sortOrder=${dataset.sortType}`) : 
                (`/api/users/?sortKey=${dataset.sortBy}&sortOrder=${dataset.sortType}`), accesstoken);
                navigate(`/users/list?sort=${dataset.sortBy}&sort_order=${dataset.sortType}${search ? `&search=${search}` : ''}`);
            }
        }

        RefreshToken((accesstoken) => callApi(accesstoken));
    }

    return(
        <>
            <div className="users-container">
                <Header />

                <div className="row users-sub-container">
                    <Sidebar />

                    <div className='col-10 users-body-container'>
                        <div className='sub-header'>
                            <Breadcrumbs/>
                        </div>

                        <ProfileHeader/>

                        <div className='user-list-container'>
                            <SearchSection values={searchValues} handleFilter="" setDownloadtype="" downloadtype=""
                            downloadarray={downloadArray} headers={headers} filename={filename}
                            callSearchApi={(query) => callSearchApi(query)}  navigateTo={createNewUser} pageType="Users"/> 
                                {isLoading ? 
                                (<Spinner/>) : 
                                (<div className='table-view-container'>
                                    <div className='list-items' id="print">
                                        <table>
                                            <thead>
                                                <tr className='heading-row'>
                                                    {tableHeaders.map((item, index) => {
                                                        return (
                                                            <>
                                                                {item.name  == "Actions" ? 
                                                                (<th className={`heading-data${index} action-heading`} style={{ minWidth: `${item.width}`, textAlign: "left"}}>
                                                                    <div className='flex-display'>
                                                                        <div className='label'>{item.name}</div> 
                                                                        {item.sort &&
                                                                        (<div className='sort-arrows'>
                                                                            {
                                                                                !(sortValues.sortBy === (item.name).toLowerCase().replace(/ /g, '') && sortValues.sortType === 'asc') &&
                                                                                <img className='uparrow' src={upsort} alt="uparrow" 
                                                                                data-sort-by={(item.name).toLowerCase().replace(/ /g, '')} data-sort-type='asc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                                            }
                                                                            {
                                                                                !(sortValues.sortBy === (item.name).toLowerCase().replace(/ /g, '') && sortValues.sortType === 'desc') &&
                                                                                <img className='downarrow' src={downsort} alt="downarrow"
                                                                                data-sort-by={(item.name).toLowerCase().replace(/ /g, '')} data-sort-type='desc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                                            }
                                                                        </div>)}  
                                                                    </div>                                  
                                                                </th>) : 
                                                                (<th className={`heading-data${index}`} style={{ minWidth: `${item.width}`, textAlign: "left" }}>
                                                                    <div className='flex-display'>
                                                                        <div className='label'>{item.name}</div> 
                                                                        {item.sort &&
                                                                        (<div className='sort-arrows'>
                                                                            {
                                                                                !(sortValues.sortBy === (item.name).toLowerCase().replace(/ /g, '') && sortValues.sortType === 'asc') &&
                                                                                <img className='uparrow' src={upsort} alt="uparrow" 
                                                                                data-sort-by={(item.name).toLowerCase().replace(/ /g, '')} data-sort-type='asc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                                            }
                                                                            {
                                                                                !(sortValues.sortBy === (item.name).toLowerCase().replace(/ /g, '') && sortValues.sortType === 'desc') &&
                                                                                <img className='downarrow' src={downsort} alt="downarrow"
                                                                                data-sort-by={(item.name).toLowerCase().replace(/ /g, '')} data-sort-type='desc' onClick={(e) => callSortApi(e.target.dataset)}></img>
                                                                            }
                                                                        </div>)}  
                                                                    </div>                                  
                                                                </th>)}
                                                            </>
                                                        )
                                                    })}
                                                </tr>
                                            </thead>
                                            {
                                                userListValues && userListValues.length === 0 ? (<p className="no-result">No results found</p>) :
                                                <tbody className='user-table-body'>
                                                    {(userListValues != null && userListValues.length > 0) && userListValues.map((item, index) => {
                                                        return (
                                                            <tr id={index} onMouseOver={(e) => addDarkImage(e, index)} onMouseLeave={(e) => removeDarkImage(e, index)}
                                                            onClick={() => handleOverview(item.idUsers)}>
                                                                <td className='data0'>{item.firstName != null && item.firstName}</td>
                                                                <td className='data1'>{item.lastName != null && item.lastName}</td>
                                                                <td className='data2'>{item.userRole != null && item.userRole.roleName}</td>
                                                                <td className='data3'>{item.email != null && item.email}</td>
                                                                <td className='data4'>{item.phoneNumber != null && item.phoneNumber}</td>
                                                                <td className='data5'>{item.lastUpdatedTime != null && convertUTCToPST(item.lastUpdatedTime + 'Z', "updates")}</td>
                                                                <td className='data6'>{item.lastLogin != null && convertUTCToPST(item.lastLogin + 'Z', "updates")}</td>
                                                                <td className='data7 action'>
                                                                    <img id={`${'edit'+index}`} className='edit' src={edit} alt="edit" onClick={(e) => handleEdit(e, item.idUsers)}></img>
                                                                    <img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" onClick={(e) => handleDelete(e, item.idUsers)}></img>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            }
                                        </table>
                                    </div>
                                </div>)
                            }
                        </div>
                    </div>
                </div>

                {/* Showing delete popup */}
                <DeleteUser show={showDeleteUser} handleClose={handleCloseDeleteUserPopup} deleteApiCall={handleDeleteUser}
                type="delete" enable={enable}/>
                
                <Footer />
            </div>
        </>
    )
}

export default Users;